/* eslint-disable rxjs/no-exposed-subjects */
import { Injectable } from '@angular/core';
import { ApiError } from '@data-access/api/error';
import { ApolloLoadingState, GraphqlError, isApolloNetworkError } from '@data-access/graphql';
import { BehaviorSubject, EMPTY, Observable, Subject, take } from 'rxjs';

@Injectable()
export class SharedFullScreenLoaderService {
  private readonly loadingStateSubject$ = new BehaviorSubject<ApolloLoadingState>(ApolloLoadingState.Loading);
  readonly loadingState$ = this.loadingStateSubject$.asObservable();

  private readonly refreshedSubject$ = new Subject<void>();
  private readonly refreshSubject$ = new BehaviorSubject<void>(null);
  readonly refresh$ = this.refreshSubject$.asObservable();

  setStateLoaded(): void {
    this.refreshedSubject$.next();
    this.loadingStateSubject$.next(ApolloLoadingState.Loaded);
  }

  setStateError(): void {
    this.refreshedSubject$.next();
    this.loadingStateSubject$.next(ApolloLoadingState.Error);
  }

  catchError$(error: ApiError | GraphqlError): Observable<never> {
    this.refreshedSubject$.next();
    if (ApiError.isInstance(error) && error instanceof ApiError && error.originalError?.status === 0) {
      this.loadingStateSubject$.next(ApolloLoadingState.ErrorNetwork);
    } else if (error instanceof GraphqlError && isApolloNetworkError(error)) {
      this.loadingStateSubject$.next(ApolloLoadingState.ErrorNetwork);
    } else {
      this.loadingStateSubject$.next(ApolloLoadingState.Error);
    }
    return EMPTY;
  }

  handleRefresh(event: any): void {
    this.refreshedSubject$.pipe(take(1)).subscribe(() => {
      event.target.complete();
    });
    this.refreshSubject$.next(null);
  }

  triggerRefresh(): void {
    this.refreshSubject$.next(null);
  }
}
